import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import Button from 'components/Button';
import SelectInput from 'components/Form/SelectInput';
import Popup from 'components/Popup';

import { createAssistantFolder } from 'api/assistants';
import { getFolders } from 'api/folders';

export default function AssistantAddFoldersPopup({
    visible,
    setVisible,
    present = []
}) {

    const { assistantId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['createAssistantFolder'],
        mutationFn: createAssistantFolder,
        onSuccess: () => {
            cache.invalidateQueries(['assistants', assistantId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating assistant-area:", error);
        }
    });

    const { data: folders } = useQuery({
        queryKey: ['folders'],
        queryFn: async () => await getFolders({}),
    });


    const selectOptions = folders?.map(folder => {
        return {
            value: folder._id,
            label: folder.name
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: assistantId,
            data: {
                folder: e.target.folder.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona cartella"
                        name="folder"
                        options={selectOptions?.filter(element => !present?.includes(element.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
